import { FormikFormSwitch } from "../../components/FormSwitch";
import useProductFormFormik from "../../hooks/useProductFormFormik";

export default function PublishedSwitch() {
  const {
    values: { uuid, published },
  } = useProductFormFormik();

  const hasBeenCreated = uuid !== undefined;

  const title = hasBeenCreated
    ? `Producto ${published ? "publicado" : "oculto"}`
    : `Producto ${published ? "por publicarse" : "oculto"}`;

  const body = `Pulsa para ${
    published ? "ocultar" : "publicar"
  } tu producto al ${hasBeenCreated ? "guardarlo" : "crearlo"}`;

  return <FormikFormSwitch fieldName="published" title={title} body={body} />;
}
